import { render, staticRenderFns } from "./SectionHeaderSmall.vue?vue&type=template&id=bf33bd4a&scoped=true&"
import script from "./SectionHeaderSmall.vue?vue&type=script&lang=js&"
export * from "./SectionHeaderSmall.vue?vue&type=script&lang=js&"
import style0 from "./SectionHeaderSmall.vue?vue&type=style&index=0&id=bf33bd4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf33bd4a",
  null
  
)

export default component.exports